module.exports = __webpack_public_path__ + "static/media/torus.d5320421.png";